export class UserProfile {
  email: string = "";
  name: string = "";
  companyId: string = "";
  role: string = "";
  lockedOut: boolean = false;
}
